export const APP_SETTINGS_VERSION_0 = 0;
export const APP_SETTINGS_VERSION_1 = 1;
export const APP_SETTINGS_VERSION_2 = 2;
export const APP_SETTINGS_VERSION_LATEST = APP_SETTINGS_VERSION_2;



// WEBPACK FOOTER //
// ./~/wix-vod-shared/src/app-settings/constants/versions.js